module.exports = __webpack_public_path__ + "img/4040_3.c296211f.png";